import React from "react";
import PropTypes from "prop-types";

import styles from "./NewsletterPromoWrapper.css";

export default function NewsletterPromoWrapper({ header, children }) {
  return (
    <div className={styles.root}>
      <h3 className={styles.header}>{header}</h3>
      {children}
    </div>
  );
}

NewsletterPromoWrapper.propTypes = {
  header: PropTypes.string.isRequired,
  children: PropTypes.node.isRequired,
};
